var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.03,
    height: 31.275,
    viewBox: "0 0 37.03 31.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-linejoin:round;}.a{stroke:#e9e9e9;stroke-width:3px;}.b{stroke:#575252;stroke-width:2.5px;}.c{fill:#ec6262;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-651.25 -246)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.006,0,32.012,26.617H0Z",
    transform: "translate(653.681 248.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.265,0,29.358,20.156l5.172,8.619H0Z",
    transform: "translate(652.5 247.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M219.989,333.382a1.764,1.764,0,1,0,0,3.528,1.765,1.765,0,0,0,0-3.528Z",
    transform: "translate(449.917 -63.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M219.087,157.226a1.918,1.918,0,0,0-1.362,1.926c.042.557.078,1.122.12,1.679.12,2.124.24,4.205.36,6.329a1.293,1.293,0,0,0,1.32,1.242,1.319,1.319,0,0,0,1.32-1.284c0-.438,0-.84.042-1.284.078-1.362.162-2.724.24-4.086.042-.882.12-1.764.162-2.646a2.179,2.179,0,0,0-.162-.882A1.769,1.769,0,0,0,219.087,157.226Z",
    transform: "translate(450.417 101.517)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.5358229905f217c64ec7351c41d3015c.svg";
export { ForwardRef as ReactComponent };